export const VCARD_CONTAINER_CLASSNAME = 'aff-container-vcard';
export const VCARD_MAIN_CLASSNAME = 'aaf-vcard';
export const VCARD_MAIN_CLASSNAME_WHIT_SCROLL = 'aaf-vcard-with-scroll';
export const VCARD_DETAILS_MAIN_CLASSNAME = `${VCARD_MAIN_CLASSNAME}-details`;
export const VCARD_ACTIONS_MAIN_CLASSNAME = `${VCARD_DETAILS_MAIN_CLASSNAME}-actions`;
export const VCARD_RESUMEN_MAIN_CLASSNAME = `${VCARD_DETAILS_MAIN_CLASSNAME}-resume`;
export const VCARD_RESUMEN_SHORT_MAIN_CLASSNAME = `${VCARD_RESUMEN_MAIN_CLASSNAME}-short`;
export const VCARD_BUTTON_MAIN_CLASSNAME = `${VCARD_MAIN_CLASSNAME}-button`;
export const VCARD_BUTTON_ICON_MAIN_CLASSNAME = `${VCARD_BUTTON_MAIN_CLASSNAME}-icon`;
export const VCARD_BUTTON_ICON_WATCH_WITH_MAIN_CLASSNAME = `${VCARD_BUTTON_ICON_MAIN_CLASSNAME}-watch-with`;
export const VCARD_BUTTON_LABEL_MAIN_CLASSNAME = `${VCARD_BUTTON_MAIN_CLASSNAME}-label`;
export const VCARD_SEASON_BUY_CLASSNAME = 'vacard-details-season';
export const PLAY_RIBBON = 'reproducir / {{RIBBON_NAME}}';
export const NODE_RIBBONS = 'carruseles {{NODE_NAME}}';
export const PBI_OFFER_SUBSCRIPTION_TYPE = 'subscrition';
export const VCARD_COMPRA = 'compra';
export const VCARD_VER_TRAILER = 'ver trailer';
export const VCARD_QUE_INCLUYE = 'que incluye';
export const VCARD_CLICK = 'click';
export const VCARD_COMPONENT = 'vcard';
export const VCARD_LABEL_AGREGAR_LISTA = 'agregar a mi lista';
export const VCARD_LABEL_QUITAR_LISTA = 'quitar de mi lista';
export const SELECCIONAR_TEMPORADA = 'seleccionar temporada';
export const VCARD_REPRODUCIR = 'reproducir';
export const VCARD_SUSCRIBETE = 'suscribete';
export const VCARD_CLARO_VIDEO = 'clarovideo';
export const CARRUCEL_VCARD = 'carrusel vcard';
export const SUPERDESTACADO = 'superdestacado';
export const SUPERDESTACADOS = 'superdestacados';




// WEBPACK FOOTER //
// ./src/components/Ficha/Constants.js